import clientLogo from "../../images/clients/Colored/Borjan.jpg"

const borjan = {
  pageTitle: "Visiomate - Borjan Case Study",
  metaDescription:
    "Visiomate built 25+ supply chain and finance reports on Dynamics 365 for Borjan, cutting a week of data preparation down to minutes.",
  clientName: "Borjan",
  bannerSummary:
    "Supply chain and finance reporting on Dynamics 365 for a 130+ outlet footwear retailer",
  introHeading: "Decision-Ready Reporting for Borjan",
  heroImageAlt: "Retail store interior",
  clientLogoSrc: clientLogo,
  about:
    "Borjan is one of Pakistan's best-known footwear brands, with over 1,000 employees and more than 130 outlets across 75 cities, plus stores in the UAE. Borjan already ran its business on Dynamics 365. What it lacked was fast, reliable reporting on top of it.",

  challengesIntro: "The data was in Dynamics 365. Getting usable numbers out of it took days.",
  challenges: [
    {
      title: "A Week to Prepare the Numbers",
      desc: "Teams spent a full week gathering and shaping data before anyone could read it.",
    },
    {
      title: "Supply Chain Decisions Waiting on Data",
      desc: "Stock and movement figures weren't available when decisions had to be made.",
    },
    {
      title: "Finance Without Timely Reports",
      desc: "Key finance figures for decision-making weren't available on demand.",
    },
    {
      title: "Reports the Standard Setup Didn't Offer",
      desc: "The reports the business needed simply didn't exist in Dynamics 365.",
    },
  ],

  solutionsIntro: "We built the reporting Borjan needed directly on the Dynamics 365 it already ran.",
  solutions: [
    {
      num: "01",
      text: "Supply Chain Reports",
      desc: "Reports that give supply chain teams their numbers on the fly.",
    },
    {
      num: "02",
      text: "Finance Reports",
      desc: "The finance figures leadership relies on for decisions.",
    },
    {
      num: "03",
      text: "Built on Their Existing Dynamics 365",
      desc: "No new system, no data migration, no change to how stores work.",
    },
    {
      num: "04",
      text: "Fast to Run",
      desc: "Each report runs in seconds or minutes, not days of preparation.",
    },
  ],

  resultsIntro: "Borjan's teams now spend their time on the numbers, not on preparing them.",
  metrics: [
    { metric: "25+", label: "Supply chain and finance reports built on Dynamics 365" },
    { metric: "Minutes", label: "To run reports that used to take a week of data preparation" },
  ],
  outcomes: [
    "Supply chain and finance decisions are made on current numbers",
    "A week of manual preparation per cycle is no longer needed",
    "Value from the Dynamics 365 they already owned, without a new system",
  ],

  relatedLinks: [
    {
      to: "/caseStudies/projects/hushPuppiesPakistan",
      label: "See how Hush Puppies Pakistan runs its Dynamics 365",
      note: "Integrations, bulk stock transfers and retail changes for Firhaj Footwear.",
    },
    {
      to: "/caseStudies/projects/cakesAndBakes",
      label: "Read the Cakes & Bakes story",
      note: "Dynamics 365 re-implemented for a bakery production facility.",
    },
  ],
}

export default borjan
